module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/4/4-a9524d90495de9f4b00c75ca94a1b377.jpg";